// extracted by mini-css-extract-plugin
export default {"buttons":"control-tab_buttons__Nxop5","button":"control-tab_button__ANGJE","active":"control-tab_active__m7XXg","container":"control-tab_container__6oPJr"};